// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__O6TLm","title":"InfoRow_title__bVlNB"};